import { Observable } from 'rxjs';
import { IDIN_DIRECTORY, IDIN_STATUS, IDIN_VERIFYID } from '../../app.consts';
import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';

import { AuthService } from '../auth.service';
import {
  GetDirectoryResponseModel,
  GetStatusRequestModel, GetStatusResponseModel,
  VerifyIdRequestModel,
  VerifyIdResponseModel
} from 'src/app/models/idin.model';

@Injectable()
export class IdinApiService extends BaseApiService {
  constructor(private http: HttpClient, protected auth: AuthService) {
    super(auth);
  }

  getDirectory(): Observable<GetDirectoryResponseModel> {
    return this.http.get<GetDirectoryResponseModel>(
      `${this.apiUrl}${IDIN_DIRECTORY}`
    );
  }

  verifyId(payload: VerifyIdRequestModel): Observable<VerifyIdResponseModel> {
    return this.http.post<VerifyIdResponseModel>(
      `${this.apiUrl}${IDIN_VERIFYID}`,
      payload
    );
  }

  getStatus(payload: GetStatusRequestModel): Observable<GetStatusResponseModel> {
    return this.http.post<GetStatusResponseModel>(
      `${this.apiUrl}${IDIN_STATUS}`,
      payload
    );
  }
}
